<template>
  <div class="app" :class="{ visible : ui.show }">
    <div class="container" id="app">
      <div class="row bg">
        <div class="col-1"></div>
        <div class="col-10">
          <header class="head">
            <svg class="logo">
              <use xlink:href="#ico-logo"></use>
            </svg>
            <button class="close" @click.stop="close">&#x2715;</button>
          </header>

          <div class="qu-cont">
            <div class="qu" :class="{ visible: step === (index + 1)}" v-for="(qu, index) in questions" :data-question="index + 1">
              <h2 class="txt" >{{ qu.question }}</h2>

              <div class="fld-cont" v-if="index === 4 && step === 5">
                <!-- date -->
                <label class="label">Enter a date:</label>
                <input class="fld" v-picker="" v-model="filter.check_in_on" type="text" placeholder="Select date" readonly />
              </div>

              <div class="fld-cont" v-if="index === 5 && step === 6">
                <!-- postcode -->
                <label class="scon" for="uiswitch">
                  Search by location
                  <div>
                    <input v-model="ui.switch" id="uiswitch" type="checkbox" class="switch">
                    <span></span>
                  </div>
                  Search by driving distance
                </label>

                <div class="fld-inner" v-show="ui.switch">
                  <label class="label">Search by driving distance</label>
                  <div class="valid" :class="{ show : ui.validPost }">
                    <input @keyup="androidNext" @focus="androidFocus" @blur="androidFocus" autocomplete="off" class="fld" placeholder="Enter your postcode" v-model="filter.travel_origin_postcode" type="text"/>
                  </div>
                </div>

                <div class="fld-inner" v-show="!ui.switch">
                  <label class="label">Search by location</label>
                  <div>
                    <input @keyup="androidNext" @focus="androidFocus" @blur="androidFocus" autocomplete="off" v-autofill="" class="fld" placeholder="Town, city or region" v-model="filter.region" type="text"/>
                  </div>
                </div>
              </div>

              <div class="fld-cont" v-if="step === 10">
                <!-- email -->
                <div :class="{ show : !ui.validEmail, valid: ui.validEmail }">
                  <input @keydown="androidNext" @focus="androidFocus" @blur="androidFocus" autocomplete="off" @keyup="validateEmail" class="fld fld-email" placeholder="Enter your e-mail" v-model.trim="ui.email" type="text"/>
                </div>

                <p class="skip" @click="createUrl">Skip this and show me my search</p>

                <button class="btn wide" @click="ajaxEmail">
                  <span v-show="!ui.eSending">Submit</span>
                  <span v-show="ui.eSending">Sending...</span>
                </button>

                <p class="terms">By entering my email address, I agree to {{ $props.brand }}'s
                  <a target="_blank" href="/term-and-conditions">
                    Terms of service,
                  </a>
                  <a target="_blank" href="/privacy-policy">
                    Privacy policy
                  </a>
                  and to receive email updates, news, & offers from us.</p>
              </div>

              <div class="btn-cont" :class="{ hidden : step === 6 && !ui.switch }" :id="qu.filter">
                <div v-for="(answer, idx) in qu.answers" v-show="qu.answers.length > 0">
                  <input :shadow-tab="idx" class="check" :name="qu.type === 'multi' ? '' : qu.id" :id="qu.id + '_' + idx" v-model="filter[answer.filter]" :type="isCheckBox(qu.type)" :value="getValue(answer)" :true-value="getValue(answer)" :false-value="''" />
                  <label @click="autoNext(qu)" class="btn" :for="qu.id + '_' + idx">
                    {{ answer.text }}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <footer class="foot" :class="{ hide: ui.android }">
            <div>
              <button :shadow-tab="ui.prevTab"  class="btn prev" :disabled="step === 1 || steps.length <= 1" @click="back">Back</button>
              <button :shadow-tab="ui.nextTab"  class="btn next" :class="{ active: ui.highlight }" :disabled="step >= 10" @click="nextStep(step)">Next</button>
            </div>
            <button class="reset" @click="resetFilter">Reset my preferences</button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
      const url = window.location.href;
      return {
          questions: [
              {
                  id: "guests",
                  type: "single",
                  question: "What kind of break are you looking for?",
                  answers: [
                      { text: "Just me", val: "1", filter: "sleeps" },
                      { text: "Couple", val: "2", filter: "sleeps" },
                      { text: "Family", val: "4", filter: "sleeps"},
                      { text: "Group", val: "3", filter: "sleeps" },
                      { text: "Other", val: "1", filter: "sleeps" }
                  ],
                  next: 2
              },
              {
                  id: "bedrooms",
                  type: "single",
                  question: "How many guests will there be?",
                  answers: [
                      { text: "3-4", val: "2", filter: "beds" },
                      { text: "5-6", val: "3", filter: "beds" },
                      { text: "7-8", val: "4", filter: "beds" },
                      { text: "9-10", val: "5", filter: "beds" },
                      { text: "10+", val: "6", filter: "beds" }
                  ],
                  next: 3
              },
              {
                  id: "pets",
                  type: "single",
                  question: "Will you be taking any pets?",
                  answers: [
                      { text: "None", val: false, filter: "pets" },
                      { text: "1 pet", val: "1", filter: "pet_count" },
                      { text: "2 pets", val: "2", filter: "pet_count" },
                      { text: "3+ pets", val: "3", filter: "pet_count" },
                  ],
                  next: 4
              },
              {
                  id: "duration",
                  type: "single",
                  question: "How long do you want to go for?",
                  answers: [
                      { text: "2 nights", val: "2", filter: "minimum_nights" },
                      { text: "3 nights", val: "3", filter: "minimum_nights" },
                      { text: "4 nights", val: "4", filter: "minimum_nights" },
                      { text: "1 week+", val: "7", filter: "minimum_nights" },
                  ],
                  next: 5
              },
              {
                  id: "startdate",
                  type: "single",
                  question: "When do you want to go?",
                  answers: [
                      { text: "Don't mind", val: this.$props.weekend, filter: "check_in_on" },
                  ],
                  next: 6
              },
              {
                  id: "travel",
                  type: "field",
                  question: "Where do you want to go?",
                  answers: [
                      { text: "Up to 1hr", val: "60", filter: "travel_max_time" },
                      { text: "Up to 2hrs", val: "180", filter: "travel_max_time" },
                      { text: "Up to 3hrs", val: "240", filter: "travel_max_time" },
                      { text: "Over 3hrs", val: "300", filter: "travel_max_time" },
                      { text: "Don't mind", val: "500", filter: "travel_max_time" },
                  ],
                  next: 7
              },
              {
                  id: "type",
                  type: "multi",
                  question: "What type of property would you like to stay in?",
                  answers: [
                      {text: "Cottage", val: true, filter: "cottage"},
                      {text: "Lodge/cabin", val: true, filter: "lodge"},
                      {text: "Apartment", val: true, filter: "apartment"},
                      {text: "Caravan", val: true, filter: "caravan"}
                  ],
                  next: 8
              },
              {
                  id: "amenities",
                  type: "multi",
                  question: "What amenities does the property need to have?",
                  answers: [
                      {text: "Wifi", val: true, filter: "wifi"},
                      {text: "Hot tub", val: true, filter: "hot_tub"},
                      {text: "Parking", val: true, filter: "parking"},
                      {text: "Fire", val: true, filter: "open_fire"},
                      {text: "Garden", val: true, filter: "garden"},
                      {text: "Near beach", val: true, filter: "beach"},
                      {text: "Accessible", val: "accessible", filter: "tags"}
                  ],
                  next: 9
              },
              {
                  id: "price",
                  type: "single",
                  question: "How much would you like to spend?",
                  answers: [
                      {text: "£0 - £300", val: "300", filter: "max_price"},
                      {text: "£300 - £500", val: "500", filter: "max_price"},
                      {text: "£500 - £1000", val: "1000", filter: "max_price"},
                      {text: "£1000 - £2000", val: "2000", filter: "max_price"},
                      {text: "£2000+", val: "10000", filter: "max_price"},
                  ],
                  next: 10
              },
              {
                  id: "email",
                  type: "single",
                  question: "Enter your e-mail address",
                  answers: [],
                  next: 11
              }
        ],
        filter: JSON.parse(JSON.stringify(this.$props.filter)),
        backup: {},
        step: 1,
        steps: [1],
        type: "",
        ui: {
            url: "/searches/custom?",
            show: true,
            eSending: false,
            shake: false,
            email: "",
            postcode: "",
            why: "",
            validEmail: false,
            validPost: false,
            showLoader: false,
            switch: false,
            currentUrl: url,
            highlight: false,
            android: false,
            shadowTab: 0,
            nextTab: "",
            prevTab: "",
            getemail: url.indexOf("email") > -1
        }
      }
    },
    props: {
        filter: Object,
        brand: String,
        auth: String,
        track: Object,
        dfc: Boolean,
        weekend: String
    },
    watch: {
        // watchers contain functional logic for the steps
        'filter.travel_max_time': function(newVal, oldVal) {
            if (newVal && this.filter.travel_origin_postcode) {
                this.calcDrive(newVal);
            }
        },
        'filter.max_pets': function(newVal, oldVal) {
            if (newVal && parseInt(newVal) > 0) {
                this.pets = true;
            }
        },
        'filter.max_price': function(newVal, oldVal) {
            let min, app = this;
            switch(newVal) {
                case "500":
                    min = 300;
                    break;
                case "1000":
                    min = 500;
                    break;
                case "2000":
                    min = 1000;
                    break;
                case "10000":
                    min = 2000;
                    break;
                default:
                    min = 0;
            }
            app.filter.min_price = min;
        },
        'type': function(newVal, oldVal) {
            this.ui.highlight = newVal !== "single";
        },
        'step': function(newVal, oldVal) {
            let email = this.ui.getemail;
            this.ui.shadowTab = 0;

            if (newVal === 2 && parseInt(this.filter.sleeps) !== 3) {
                this.step = 3;
            }

            if (newVal === 10 && (email || this.ui.validEmail)) {
                this.step = 11;
            }

            if (newVal === 11) {
                this.createUrl();
            }
        }
    },
    directives: {
        'picker': {
            inserted: (el, binding, vnode) => {
                el.pikadayInstance = new Pikaday({
                    theme: "pika--ctr",
                    field: el,
                    bound: true,
                    keyboardInput: true,
                    format: 'D MM YYYY',
                    firstDay: 0,
                    reposition: false,
                    minDate: new Date(),
                    onSelect: function onSelect(date) {
                        let newDate = st.getUserDate(new Date(date));
                        el.value = newDate;
                        vnode.context.filter.check_in_on = newDate;
                    }
                });
            },
            unbind: (el) => {
                el.pikadayInstance.destroy();
            }
        },
        'autofill': {
            inserted: (el, binding, vnode) => {
                let app = vnode.context;
                el.autofill = new autoComplete({
                    selector: el,
                    minChars: 1,
                    cache: false,
                    menuClass: "app-autocomplete-suggestions",
                    source: function (term, suggest) {
                        if (term.length > 2) {
                            let url = "/searches/autocomplete?query=" + encodeURIComponent(term.toLowerCase());

                            fetch(url, app.getRequest())
                                .then((resp) => resp.json())
                                .then(function(data) {
                                    let newData = app.sortSuggestionLists(data, term);
                                    suggest(newData);
                                });
                        }
                    },
                    renderItem: function (item, search) {
                        search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
                        if (item.includes(",")) {
                            return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>").replace(",", "+").split("+")[0] + '<br /><span class="sub-region">' + item.replace(re, "$1").replace(",", "+").split("+")[1] + '</span></div>';
                        } else {
                            return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "<b>$1</b>") + '</div>';
                        }
                    },
                    onSelect: function (e, term, item) {
                        e.preventDefault();
                        app.filter.region = term;
                    }
                });

                setTimeout(function() {
                    el.parentNode.appendChild(document.querySelector(".app-autocomplete-suggestions"));
                }, 500)
            },
            unbind: (el) => {
                el.autofill.destroy();
            }
        }
    },
    methods: {
        close() {
           this.ui.show = false;
           this.toggleBodyLock();
        },
        pushStep: function(next) {
            this.steps.push(next);
        },
        nextStep: function(step) {
            let app = this;
            let newQuestion = this.questions[step - 1],
                filter = JSON.stringify(app.filter),
                last = app.$el.querySelector(".qu.visible").querySelectorAll("[shadow-tab]").length;

            app.step = newQuestion.next;
            app.type = newQuestion.type;

            app.pushStep(app.step);
            app.pushUrl();
            st.getOrStoreData("landing_modal", filter, "STORE");
            app.sendTracking();

            Vue.set(app.ui, "nextTab", last + 2);
            Vue.set(app.ui, "prevTab", last + 1);
        },
        autoNext(qu) {
            let app = this;
            if (qu.type === "single") {
                app.nextStep(app.step);
            }
        },
        back() {
            let app = this, last = app.steps.length;
            app.ui.validPost = false;
            app.ui.showLoader = false;

            if (app.steps.length > 0 && app.steps[last - 2]) {
                app.step = app.steps[last - 2];
                app.steps.pop();
                app.pushUrl();
            }
        },
        androidFocus() {
          this.ui.android = !(this.ui.android);
        },
        androidNext(e) {
            if (e.keyCode === 13) {
                e.currentTarget.blur();
            }
        },
        getRequest() {
            return {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json; charset=UTF-8',
                    'X-CSRF-TOKEN': st.getCSRFToken()
                }
            }
        },
        validatePost() {
            let app = this;
            let postcode = app.filter.travel_origin_postcode;
            let url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + postcode + ".json?country=gb&access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g";
            fetch(url, app.getRequest())
                .then((resp) => resp.json())
                .then(function(data) {
                    app.ui.validPost = data.features.length > 0;
                });
        },
        isValidEmail(value) {
            let filter = /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;
            return filter.test(value);
        },
        validateField(e) {
            return e.currentTarget.value.length > 0
        },
        validateEmail() {
            this.ui.validEmail = this.isValidEmail(this.ui.email);
        },
        resetFilter() {
            let app = this;
            app.ui.validEmail = false;
            app.ui.validPost = false;
            st.getOrStoreData("landing_modal", "", "STORE");
            Vue.set(app, "filter", app.backup);
            app.step = 1;
            app.steps = [1];
        },
        pushUrl() {
            let app = this;
            let step = app.ui.currentUrl.indexOf("?email") > -1 ? "&step" : "?step";
            history.pushState({}, "", app.ui.currentUrl.split(step)[0] + step + app.step);
        },
        sendTracking() {
            let app = this;
            if (window.td) {
                window.td.trackEvent("uiactions", {
                    category: "searchapp",
                    value: app.filter,
                    visitor_email_id: app.$props.track.visitor_email_id,
                    tracking_profile_id: app.$props.track.tracking_profile_id
                });
            }

        },
        getValue(answer) {
            return typeof answer.val !== 'undefined' ? answer.val : answer.text
        },
        isCheckBox(type) {
            return type === 'multi' ? 'checkbox' : 'radio'
        },
        sendAJAX(time, callback) {
            let app = this;
            let postcode = app.filter.travel_origin_postcode;
            let url = "https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(postcode) + ".json?country=gb&access_token=pk.eyJ1Ijoic25hcHRyaXBrcmlzIiwiYSI6ImNqa2RvejJucDB5bm4zcnM1ZDlyOHVqZnQifQ.VZTOARdDaid-d4yf2Q182g";
            fetch(url, app.getRequest())
                .then((resp) => resp.json())
                .then(function(data) {
                    let position = { lng: data.features[0].center[0], lat: data.features[0].center[1] };
                    new en.iso({ position: position, time: time, callback: callback});
                });
        },
        calcDrive(time) {
            let app = this;
            let postcode = app.filter.travel_origin_postcode,
                callback = function(response) { app.filter.isochrone_uuid = response };

            if (postcode && postcode.length > 3) {
                this.validatePost();
                app.ui.showLoader = true;
                setTimeout(() => {
                    app.filter.travel_max_time = time;
                    if (!this.ui.validPost) {
                        app.ui.shake = true;
                        setTimeout(function() {
                            app.ui.shake = false;
                        }, 500);
                        app.ui.showLoader = false;
                        return;
                    }
                    this.sendAJAX(time, callback);
                }, 600);

            } else {
                app.ui.shake = true;
                setTimeout(function() {
                    app.ui.shake = false;
                }, 500);
                return;
            }
        },
        ajaxEmail() {
            let app = this, url = "/visitor_emails";
            let data = {
                visitor_email: {
                    email: app.ui.email,
                    form: "landing_app",
                    method: "searchapp"
                }
            },
            request = {
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRF-TOKEN': st.getCSRFToken(),
                    'Authorization': app.$props.auth
                },
                body: st.serialize(data)
            };

            app.ui.eSending = true;

            fetch(url, request)
                .then(function(res) {
                    st.getOrStoreData("saToken", "1", "STORE");
                    setTimeout(function() {
                        app.createUrl();
                    }, 100);
                    app.ui.eSending = false;
                });
        },
        cleanFilter() {
            let app = this;
            for (const property in app.filter) {
                let fil = app.filter[property];
                if (fil === "") {
                    delete app.filter[property];
                }
            }
        },
        minPrice(max) {
          let min, app = this;
          switch(max) {
              case "500":
                  min = 300;
                  break;
              case "1000":
                  min = 500;
                  break;
              case "2000":
                  min = 1000;
                  break;
              case "10000":
                  min = 2000;
                  break;
              default:
                  min = 0;
          }
          app.filter.min_price = min;
        },
        createUrl() {
            let app = this, filter, search;
            setTimeout(function() {
                app.cleanFilter();
                app.minPrice(app.filter.max_price);
                app.sendTracking();
                filter = app.filter;
                search = { search: filter };
                window.location.href = app.ui.url + decodeURIComponent(st.serialize(search));
            }, 250);
        },
        toggleBodyLock() {
            document.body.classList.toggle("body--lock");
        },
        catchPop(e) {
            let app = this;
            if (e && e.state) {
                app.back();
            }
        },
        resetShadow(e) {
            this.ui.shadowTab = 0;
        },
        surfTabs(e) {
           let app = this, tab;
           let last = app.$el.querySelector(".qu.visible").querySelectorAll("[shadow-tab]").length,
               foot = app.$el.querySelector('.foot');

           Vue.set(app.ui, "nextTab", last + 2);
           Vue.set(app.ui, "prevTab", last + 1);

           if (app.ui.show && e.keyCode === 9) {
               e.preventDefault();
               tab = app.$el.querySelector(".qu.visible").querySelector("[shadow-tab='" + app.ui.shadowTab + "']");

               app.ui.shadowTab++;

               if (tab) {
                   tab.focus(); 
               } else if (foot.querySelector("[shadow-tab='" + app.ui.shadowTab + "']")) {
                  foot.querySelector("[shadow-tab='" + app.ui.shadowTab + "']").focus();
               } else {
                  app.resetShadow();
               }
           }
        },
        sortSuggestionLists(response, term) {
            let matchedArray = [];
            let unmatchedArray = [];
            let newArray = [];
            let inputValue = term.toUpperCase();

            response.forEach(value => {
                let locationName = value.split(",")[0].toUpperCase();

                if (locationName.indexOf(inputValue) === 0) {
                    matchedArray.push(value);
                } else {
                    unmatchedArray.push(value);
                }
            });

            newArray = [...matchedArray, ...unmatchedArray];
            return newArray
        },
    },
    mounted: function() {
        let app = this,
            prevData = st.getOrStoreData("landing_modal", null, "GET"),
            ua = window.navigator.userAgent;
        let androidClass = /Android/i.test(ua) ? "android" : "";

        app.toggleBodyLock();

        window.addEventListener("popstate", app.catchPop);

        app.backup = JSON.parse(JSON.stringify(app.$props.filter));

        if (window.location.href.indexOf("step") > -1 && prevData !== null && prevData.length > 1) {
            app.step = parseInt(app.ui.currentUrl.split("step")[1]);
            app.filter = JSON.parse(prevData);
        }
        
        if (androidClass !== "") {
            this.$el.classList.add(androidClass);
        }

        if (!this.ui.email && (this.track.visitor_email_id !== 0)) {
          this.ui.validEmail = true;
          this.ui.email = this.track.visitor_email_id;
        }

        window.addEventListener("keydown", app.surfTabs);
        document.body.addEventListener("click", app.resetShadow);
    }
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.pika--ctr {
  position: fixed;
  top: 50% !important;
  left: 50% !important;
  transform: translate3d(-50%,-50%, 0);
}

.app-autocomplete-suggestions {
  text-align: left;
  cursor: default;
  border: .063rem solid #fff;
  border-top: 0;
  background: transparent;
  z-index: 1001;
  box-shadow: -.063rem .063rem .188rem rgba(0, 0, 0, .1);
  position: absolute;
  left: 50% !important;
  top: inherit !important;
  transform: translate(-50%,0);
  max-height: 12.5rem;
  overflow: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  border-radius: 0 0 .25rem .25rem;

  .autocomplete-suggestion {
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 3rem;
    padding: .5rem;
    box-sizing: border-box;
    font-size: .875rem;

    &, .sub-region {
      color: $col_white;
    }

    &:hover,
    &.selected {
      background: rgba(255,255,255,.3);
    }
  }
}

</style>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

$col1: #424F98;
$col2: #E41E53;
$col3: #FCA121;

// NEW

.app {
  position: fixed;
  background: $col_orange;
  z-index: 101;
  width: 100%;
  height: 100%;
  top: 0;
  left: -100%;
  transition: all .25s ease-in-out;
  background-image: linear-gradient(-45deg, $col1, $col2, $col1, $col3);
  background-size: 400% 400%;
  animation: bg 15s ease infinite;

  &.visible {
    left: 0;
  }
}

.col-10 {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.bg {
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPgAAADeCAYAAAAQJM0gAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyRpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo0REE2MzQwM0JFMUMxMUVBODExNDlFNTQyOTM4NDQ2QSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo0REE2MzQwNEJFMUMxMUVBODExNDlFNTQyOTM4NDQ2QSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjJDOEQ4MTMyQkUxQTExRUE4MTE0OUU1NDI5Mzg0NDZBIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjREQTYzNDAyQkUxQzExRUE4MTE0OUU1NDI5Mzg0NDZBIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+BNn37gAAFLZJREFUeNrsnQly4sgShksSQtieOcGLuf/BJuYEM20b0PIkR2aTlCUkRBUg+fsiCNpuLLTUn0stWUnTNA4A1knKLQBA4ACAwAEAgQMAAgcABA4ACBwAgQMAAgcABA4ACBwAEDgAIHAAQOAACBwAEDgAIHAAQOAAgMABAIEDIHAAQOAAsCg23AJ4RpIk+fa7v/76XyJOyb4S83Lm3acx7/qq7evvv//5VkN86WXFk3tfQN+De3Ly9lVIw+lu1n8jn8/a125qdNTe/3+Rc387aQWt9zOX99gRZyf0qn0du/dW8IsXOB58mlgnt8v29XLBi8BEWnGncu+zHk+sXrcx743x0peej75S8+7/uzMoVXsOn3J8BB7wfHJjqWuxpuWD7093Hp8TGlBmxP0+4fMwzItpB6W8Oq9aRzQomTzzjfy7O4dfCDxARCbW2j+fVH7XhU0fdxJMYYSqDaySl57rduDeJV6oB/Ox9/6gIXMsOsPRilwjg+ROKcGPEXhhzqU0Htta052IPCY7iSD8vGzvfebSfWvE20O4NOm1u6+tANXQ/g7R+zrGJnrsxAvLMy8CWwWbBz+4XG6onsfBE9NRvKUagBcRUBkpbM/N91bmu6yHtuda94i7IjQPSmWEt/HbbCtUP/9uLkSJfh4+9p0IPKCnbDxxOyOk3ITrKsQyokc/DoTYifeZGv1FR/s+MhM2pyZ8HhPrGHaoTCOE7nhvCHweWyNum9teyln3xqKmxpIXA0bh2lwv7znHekTgW+PhybcjImH4WdQmQ2i2N/zacXAN8YfCd0L0AGHw1FzVD8kLYyhuFbh2ml17X3IvLIf7ip57/6QCt0MfcylFlGq5Q+W8xyvvHePdgMB7QiUdhpgr8swLt0JRPfm9A3h6gWvPuHrgcoa4twGigD52NAlA4LdxcKce0dx97+CaSh0g/7bHsulDPSHFqE0UAYDAjSDe3Wk2WDLj70sxFKHCcp2O+Ke8fw6E6524dfjkwzFMBgj8oic/8AgA4pFy7QB48DXRpQSFO82Gm7JKDACBLwC/GMNGcupP97glqXBnzCw4N3exCgJ/PnT2m+0D0MUu3SKWI03/qUXZGeV6zpJRmXqq05vtPHZdrPK1JLU9doXAl++1K/HYtYhcl3/myOip6Z5T0gpSFwJdXB8uotah2M1IyvYl/vZv9u0xDwh8uV5778577jvr/eHO6645+bkmN386UnlOX89OCjTY5aL+Gm/nPWs1DvbZ6sQpreaCwBfSEGzJn9pdHrfWB79z50X+hsbD4XFYIWcTPls6U0Sxh9J4e3LwBbA1Vl5z7X1P2F7I/5XGCLybv++Mw+vA38Pj2ItgswueWssg//iJSGsSuF+Fsx7wwDZs1861vQnZVPQ7E75tHMNpT4N44oro6ucIvM9rHzxB+mG7hnp94fiQN6enHRD4A722dppVE8P2vnD84Hlzzc37Kr8AIPBI+D3ffqg9JWy/FI7bUlK/3Pce+RDVZAAQuIdfQ13LFJcTvbbP1M61vTEGqTsNrSx+9wtA4M90vjvjtfvmkk/tbPNRb/5iBLxx58NrlRiDwuTur+7UswvhsMNh+hxjbUbgr/FPzDksPoddktfWfb/Ua/u7neQiuMyE7e9uem9rLeH4wdyfNy8097/bPzcIw1ARjhjj1dnIdyLwyF77zZ06uEoR4dEzAC/Gu2tn29yhrb0YBn3AhRgOe7/88/DPE8IIPDP3++tnmZceBLMn2dl3IPDn8tpvJt04ivBuXR1Wed48w5vfld/bV3Wrv2TSSmX6V0Khx6pkfzKbupYIPB6v7nyDhPfIXjuENy89b47IbxO4navgjLHNQ3hxOca3Y5v2tHiBJ/fe4Lzb2H0if5obv+8J28c622JEFIU73/Cgr3PN9t7/Ggvzlr7BfMx20gpQhya1b8SZPpav0Y8bNx9UQ60OxIlh7n7XLR/dL/35LCEHr2aE7TGYGo5TOCIcR9NOc5miqob8azhzzjZDnri/nqsc2+5Nv4pRkSV48A8RTdYjpsY9Zigj6TkPHYu3lVfx4De2E+PFG/HYXZ6c+Ua+/X05UdwbP63rCj1IuP4qv//y3mt4PksYB1dPmU8Q2iPP8cWFLecMpz4QrcTy0grxXQT5YUT+InuHd1639MN2U9FF5y44T9yJOVbIevt48Ake3A+TbWj+aAoT5vVdGB48QDvxvOvv3FuEWfQYf1vQIelJRb+mNZtj2HD93S4zXfrzWZLA90ZUttPlkWiHz0HOqfCEjsADtRMvLK8lLK+MAdBdci5tH9wJ+6gClmPujLg//LpsCDy+wG01lm2PwGPvJ6ahn05fVWPTeALfu+/TZBF4wHbiidzJfT/YkFzEnrrz6aZnxR/Ea2/N8+wVNwKPL3B/iKxP4H9EzsN1H3PbefbfgMD980TggduJiNNfbHSU/o/BQowygSUzufjZEOvQcBsCjyfwzA2v67YCLyKfci0NKPE8uLsgcGfCvgaBh20nItZcnkfqheH1QA6eeo5Aq+oeL1VnReDxBN7H9olz8Fk9rwh8fjsx00rHSiNbtAhjOaXGOgIP8+Ay4/GqC15vqQLfmM6hCoGHdwQSuqemLeUmxdL7Xl878w2B3/bg/DppGmYN7Ty6NIH7U2o1NPy9Ph2Bh4/0ROx/aH/JLdsTMVX1hmfozhdtaN40NLa5NDbuvMfXrjV+dexuCndqhI9i685XgVXuvBxT4eLNB07MdzcRr8/Jden8dTtho5DfA6xS4HaRfeWF55qzpi7contbhsmfR65TTOsI12ertGrPbYEHh7ULfFIKFOg4uRueEKPrjbVKaui55MnIzwCrFHjlTvuA2XLHdnZRCIHb9dnqQXUDOl2EoOOpOtU0xGKD2kQNR8/YOEclVrgD6QO/dzvQ0Cvj6bYBvqcwqYBWhamNEdEST0djEG41fHZdcdUjfDWuGU0Q1ihw66XfPU998MR2C9Zzj1V8saWVi0DXp5VmLLYM85YmCGsUuC1r3Ce6g/Hic71cYjzxYWK4vzf3Jb3he1PvOvx+hYN3HwBWJfBkJA+tez57y7VNLaNUBbg3fg/9peujww1WKfB708z4LOIDBP7DjcGtEQzAKgU+tg1NNhCux+gL6GaWhSwa0QxcR9/1MVQGqxS45sR9y/wSI7g6sgi0CF8e8F7Ygvl9M9Z0m+Jr+gYAZvGoiS46HVVL8JTufOKJhrCfdziPNIIh2cu1ddfRVYHR0YLU3HOddAOwOoF3aNnbrOc8tGpqFfkcdG/wGMf9cKeCfvnA/7NWFFYrcJ3kkkkom7nTdkDlChq/bl6Yu9MU2Mqd9iEHWG0O7guhNKI/rsyz2amxFeKGnyZwAFhZiO4blmSi0UnMe3rFd1xjyK75DnflZ/s+x1BZ3Palu4f+SB5Vky12LfPF0N7/f7kLg+3kG1JvLRkRtx2e1L3GLhnSZq110Tc0JVgYuyvbrRb2vETXL7LK8ll3F7hYxP9opwArDNEB4H7Qiw6AwAEAgQMAAgcABA4ACBwAEDgAAgcABA4ACBwAEDgAIHAAQOAAgMABEDgAIHAAQOAAgMABAIEDAAIHQOAAgMABAIEDAAIHAAQOAAgcABA4AAIHAAQOAAgcABA4ACBwAEDgAIDAARA4ACBwAEDgAIDAAeB2Nks4ySRJvv3ur7/+l4iBsq/EvJx592nMu75q+/r773+ab3/UNLQYWBTJEhptJ/BW0N0/s/aVy3vs6KMTetW+jt17K3gEDnjwGLTi7sS8E2H7nli9bmPeG+OlB+2GeaXm3f93Z1Cq9hw+5fhwZbT15HTPt5Bn3rWZ/0Y+n0lbnORgWqfwLwIf58Xc0FJenVetIxqUTO7PRv7dncMvJLwqVKyT7Ze0g8VYsaUIXMXdhcwHDZlj0RmOVuQaGSR3Sgl+SsSYm3tZSwpUPrj9d+fxOSHqy4y43yd8HoHPsLiv3Y1tBViJ4H+H6H0dYxM9duKF5Zn3MOHGyF085abHcG/kOX7cSTCFebbWcVTmXLcD2kiMQajw4OGpzMPZ+OffCtXPv5sLDc7Pw8e+E24T1cZLsZyXAu1E5DHZSQRh6cS69z5zSReNeHtC9AhoGJWZsDk1lnhMrGPYoTK16t3x3tDorGgrN8bYSXplxXQUb6kG4EWebxkpbM/N91bmu6zht+da94i7WkJovlSBOwnDzxqADKHZ3vBrx8E1xB8K3+F2T9l44nZGSLkJ11WIZUSPfhwIsRPvM4sfNdmsoTWJMJul5EUrZ2vEbXPbS89mb9Kg1ITuxYBRuIa0x9hsB8SbeJ9RZ1IhcIDvYfDUXNUPyQtjKG4VuHaaXdvucy8sR+AA7ny+wlxKEaWmW6Fy3uOV2lh8eobAITSNO80dmCvyzBwrZIdW9dO0gcAhNNozrh64nCHubYAooI/dT3sYCBxCc3CnYczcfe/gmkodIP+2x7LpQz0hxahNFIHAAYwg3t1pNlgy4+9LMRShwnJdQ/CnvH8OhOuduHXOw4djmAzgoic/cBseCwsogLZNDr5ezCw4N3exCjwV3bMs3Gk23JRVYgj8yUTZWed6zpJRmXqqM6XsPHZdrPK1JLU9NrPilodfjGEjOfWne9ySVAQ+g+4hJq0gdU7xxfXhImrt1d2MWP8v8bd/s2+PSQ65HHT2m+0D0MUu3SKWIwJfXo5VyL8bKdBgl4v6a7wtjTstOKhNCKdjsFrNBYEvz2tX4rFreX66/DNH4MvDCjmb8NnSmSKKPZTG28PyvPbeM8rdM/9w53XXnPxc/4TcfOkC34tgswueWssgUzBxPaTuvE5f7S6PW2u0tnPnlXmHxsMR+LMgnrhyLBX9KWxNaqa59r4nbC/k/0pjBN7N33fG4XXg7xE4wAO8ti2dXQ94YBu2a+fa3oTjKno9ls64W+VwGgKHpXrtgydIP2zX/pm+cHzImx8ROMDjvLZ2mlUTw/a+cPzgeXPNzfsqvyBwgEj4Pd9+qD0lbL8UjttSUr/c9x75ENVkEPhE7HCYPshYmxH4ywUTcw4QH7+GupYpLid6bZ+pnWt7YwxSd5oPsegtq5YyIX9oPW+M8eps5DshrsN5c+c11H954laBFp6Ax7ztQY5VGwPx5mmgkmMdTVt4XXLovjSBZ+bBf/0s89KDYPYkO/sOBH43r637fqnX9nc7yUVwmQnb3930IdJaRH4w7f/NC8397/bPDYFH4PdOGN3qL5m0UhlLHAo9ViX7kznPm0A8r517XvvoGYAXEZoagA83f2hrL4ZBjXYhhiP12pw9D/88EXhggdthD2escB7Ci8sxvh3bNCgE/jivbcP2Y0/YPofK8+bZGr15soRN7bs9p1sBai+nhlnOhGtfediNmw+qBdc8zJkcrVs+ul/CvXqGZzURm//aBSK+ARjrbAvV77KbcT6/xiKIR7eZJVW9OJpzzmWKqoZoXx0vc7YZ8sT91Yjk2Hab2yPSjdb2Dl64bMPhS51tIZnSuaZpwd4IPlnKTX56JO/WcKroQmr53YcR+Vv7+80V4t4YT/L1ACX3tktRDyxUiUo1I2yPwdRwfFGp2tImuuzdqRLLSyvELiyv2vcP8yBeZO/wr43l/bDdVHTRKYzOiLuS/9djhSzdC+Nhcl9uu3VhO1LnaGSxVWEWk4Mbgeo4aGJzbxFm4fr3f26Mh0h7Qv+9OYYN19+t9yYHD5qD2xLGmVtG77SWc36Vn3+5keHTR7eZxQlcRJ55XvZTa6iZ3vDcXd4+uBP2UQUsx9x54Xr1TA9rpQL3n4sNzR9NYdpD34Uh8FiNxhO5dtYcbEguYk/d+XTTs+IP4rVtGNgrbgQeXeB7Iyo7UvJIdJTmIOdUeEJH4DEbjYjTH7o4Sig1WIhRJrBkJhdPTAj2OTTchsCjCNxWY9n2CDz2fmLaX5MaI6+LWqzA9+774hYEHrvRiFhzeTipF+7VAzl46lli7aE/XqrOisCDC9xf8NEn8D9c3OEo3cfcblv034DA/fNE4PdqNGZa6VhpZL/TRHvbRz+MwIMKPHPD67qtwIvIp1xLG0g8D+4uCNyZ3LxB4PdrNDZ014UjdgrqUR5oJbn4VRePwMM/qwkCf5YcfNZwKQKP3GhE7H9o6HXL9kQIfPazyozHqy54vaUKXHdRrf2o5NFthoouEBO/Tpr2jaxl59FOPzv3vT/nacoxswMjRHPm7nwJpnZ2Dk1IWqK47TCtLRDy+izawoNDLLbufO125c5XZHUij7WIJzHf3US8PifXZddDvBoj9oHAYa3YyjiVF55rzpq6cJVydBx744XMupb/4MJW5dHrs1Vadbi1wIMDhPOuuRueEKNFQrRKaujcPxn5GYHDKqncaRGJLXdspwSHELitrqoeVHeN1ZWDOglKp5qGWCFYm6jh6Bkb556khh+dbBCrXW0HGnplPN02wPcUJhXQog21MSJa4uloDMKtjs0WA6l6hK/OM0PgsEasl373PPXBE9stWM89VoDRDl0Vga6vdN9XvdldTrcIHNaILWvcJ7qD8eJzvVxiPPFhYri/N+0+veF7U+86/H6Fg3cfEDisimQkD617PntL251aaaUK0Pb9HvpL15cgcIDbaWZ8NvkJNwaBA8YgXgSDwGGVjO0dlw2E6zH6ArqZZSGLRjQD19F3fTUChzWiOXHf2vzECK6OLAKtnJsHbOt2l5u+GWu6TfE1fQPRYKILxECno2rdvNKdTzzREPbzDueRRjAke7m27jq6KjA6WpAaTdk6/ggcVofWqs962plWTY29pFK3Fo5x3A93qsKbD/x/g8Bhregkl0xC2Ux+t3enzSSXjG5emLvTFNhKvPbTbJBADg73EEJpRH9cgbgtdmps5Z5s95OfIPAUgwY/lUWH6FJvLRkRt513vGv/Zu8ud7g0t9Rtg15Dmkw0sol5T6/4jmsM9zXf4a78bN/nagQ+n92V16A1wi7RhVgfaPQmXgcMr609PiaUtyu+723GORZu+qITXU8+53P/EqIDQBQSSgED/JxcCQAQOAAgcABA4ACAwAEAgQMAAgdA4ACAwAEAgQMAAgcABA4ACBwAgQMAAgcABA4ACBwAEDgAIHAAQOAACBwAEDgAIHAAeBD/F2AAk+WNhkMdSDwAAAAASUVORK5CYII=');
  background-repeat: repeat;
  width: 100%;
  height: 100%;
}

.btn-cont, .fld-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 1.25rem 0;
  position: relative;
  box-sizing: border-box;
  padding: 0 .625rem;
  transition: opacity .2s, visibility .2s;

  &.hidden {
    visibility: hidden;
    opacity: 0;
  }
}

.show {
  width: 100%;
}

.valid {
  width: 100%;
  position: relative;

  &::after {
    content: "";
    background-color: $col_green;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23ffffff' id='icon-checkmark' viewBox='0 0 512 512'%3E%3Cpath d='m449 76l-283 282-103-104c-15-15-38-15-52 0-15 14-15 37 0 52l129 130c7 7 16 11 26 11 9 0 19-4 26-11l309-308c15-14 15-37 0-52-14-14-37-14-52 0z'%3E%3C/path%3E%3C/svg%3E");
    background-size: 50%;
    background-repeat: no-repeat;
    background-position: center;
    color: $col_white;
    position: absolute;
    width: 1.25rem;
    height: 1.25rem;
    left: 80%;
    font-size: 1.25rem;
    border-radius: 100%;
    padding: .313rem;
    bottom: .625rem;
    fill: $col_white;
    z-index: 3;
  }
}

.fld-cont {
  flex-direction: column;
}

.scon {
  font-size: .75rem;
  padding-bottom: 2.5rem;
  display: flex;
  color: #fff;

  div {
    position: relative;
    margin-left: .5rem;
  }

  span {
    transition: all .2s;
    position: absolute;
    top: 0;
    cursor: pointer;
    height: 1.25rem;
    width: 1.25rem;
    border-radius: 1.25rem;
    display: block;
    background: #F1F1F1;
    box-shadow: 0 .063rem .063rem rgba(0,0,0,.3);
    z-index: 1;
  }

  input {
    display: inline-block;
    font-size: 1.25rem;
    margin-left: .625rem;
    width: 2.813rem;
    height: 1.563rem;
    top: .188rem;
    transition: all .2s;
    cursor: pointer;
    appearance: none;
    outline: none;

    &:checked {
      & + span {
        transform: translate3d(100%, 0, 0);
      }
    }

    &:before {
      content: "";
      position: absolute;
      top: .188rem;
      left: 0;
      width: 2.5rem;
      height: .875rem;
      border-radius: 1.25rem;
      background: rgba(31, 34, 36, .26);
      z-index: 0;
    }
  }
}

.close {
  position: absolute;
  font-size: 1.25rem;
  padding: .313rem;
  top: 1.25rem;
  right: 1.25rem;
  color: $col_white;
  font-weight: 700;
  z-index: 9;
  cursor: pointer;
  background: transparent;
  outline: 0;
}

.foot {
  height: 20%;
  min-height: 13rem;
  text-align: center;

  .android &.hide {
    display: none;
  }
}

.head {
  height: 20%;
  width: 100%;
  position: relative;
}

.qu-cont {
  min-height: 60%;
  width: 100%;
  overflow: hidden;
  position: relative;
}

.qu {
  width: 100%;
  padding: .625rem;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: -100%;
  transition: all .5s ease-in-out;
  opacity: 0;
  
  &.visible {
    left: 0;
    opacity: 1;
  }
}

.logo {
  fill: $col_white;
  height: 2.5rem;
  width: 6.25rem;
  margin: 1.25rem 0 0 0;
  position: absolute;
  left: 1.25rem;
}

h2, .label {
  color: $col_white;
  margin-bottom: 1.25rem;
  text-align: center;
  display: block;
  width: 100%;
  padding: .625rem;
  box-sizing: border-box;
}

.reset, .terms, .terms a, .skip {
  background: transparent;
  color: $col_white;
  font-size: .875rem;
  text-align: center;
}

.skip, .reset {
  cursor: pointer;
}

.skip {
  margin: 1.25rem 0;
}

.terms {
  max-width: 60%;
  margin: 0 auto;
}

.reset {
  margin-right: .625rem;
}

.label {
  display: none;
}

h2 {
  font-size: 1.75rem;
  margin-bottom: 1.75rem;
}

.btn {
  border: .125rem solid $col_white;
  background: transparent;
  margin: 0 .625rem .625rem 0;
  width: auto;
  padding: 0 .938rem;
  height: 3rem;
  cursor: pointer;
  text-align: center;

  .btn-cont div:last-of-type & {
    margin: 0 0 .625rem 0;
  }

  &, span {
    transition: background .2s ease;
    color: $col_white;
    font-size: 1rem;
  }

  .btn-cont & {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &.wide {
    width: auto;
    padding: 0 1.25rem;
  }

  &.selected,
  &:hover {
    background: $col_white;

    &, span {
      color: $col_purple;
    }
  }

  input:focus + &,
  &:focus {
    outline: .0625rem solid rgba(255,255,255,0.75);
    outline-offset: -.5rem;
  }

  &.active {
    animation: pulse 1.5s infinite;
  }

  &.next,
  &.prev {
    &:disabled {
      opacity: .5;
    }

    &:hover {
      background: $col_white;
      color: $col_purple;
    }

    &:disabled:hover {
      background: transparent;
      color: $col_white;
    }
  }
}

.check {
  position: absolute;
  top: 0;
  left: -9999rem;
  pointer-events: none;

  &:checked + label {
    background: $col_white;

    &, span {
      color: $col_purple;
    }
  }
}

.fld {
  height: 100%;
  padding-bottom: .313rem;
  border-bottom: .125rem solid $col_white;
  outline: 0;
  text-align: center;
  font-size: 1.25rem;
  color: $col_white;
  max-width: 800px;
  width: 75%;
  cursor: pointer;
  display: block;
  margin: 0 auto;
  background: transparent;

  &-inner {
    max-width: 800px;
    width: 75%;
    text-align: center;

    &, div {
      position: relative;
    }
  }

  &,
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    background-color: transparent;
  }

  &.shake {
    animation: shake .5s infinite;
  }

  &::placeholder {
    opacity: .5;
    color: $col_white;
  }
}

@media #{$desktop} {
  .logo {
    left: 0;
  }

  .valid {
    width: 75%;
    margin: 0 auto;
  }

  .scon {
    font-size: .875rem;
  }

  .btn {
    width: 7.5rem;
    height: 3.75rem;

    &, span {
      font-size: 1.1rem;
    }
  }

  .foot {
    min-height: inherit;
  }

  h2 {
    font-size: 2rem;
  }
}

@keyframes bg {
  0% {
    background-position: 0 50%
  }

  50% {
    background-position: 100% 50%
  }

  to {
    background-position: 0 50%
  }
}

@keyframes pulse {
  from {
    background: transparent;
    color: $col_white;
  }
  50% {
    background: $col_white;
    color: $col_purple;
  }
  to {
    background: transparent;
    color: $col_white;
  }
}


@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

</style>
